import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const RegulatoryCompliance = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Regulatory Compliance</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              Navigating India’s complex regulatory environment requires
              precision and foresight. Our regulatory practice focuses on
              assisting clients with sector-specific compliance, licensing, and
              interaction with statutory authorities. We provide advisory and
              representation in areas such as environmental laws, competition
              regulations, securities and exchange compliance, foreign direct
              investment, and sectoral regulators. Our team helps businesses
              minimize risk by ensuring proactive compliance and effectively
              resolving regulatory disputes.
            </p>
            {/*  <ul>
              <li>Mining lease agreements.</li>
              <li>Representation before tribunals.</li>
              <li>Legal audits and compliance.</li>
              <li>MMDR, EIA, and Forest Act guidance.</li>
            </ul> */}
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default RegulatoryCompliance;
